import { useState, FormEvent } from 'react';
import { login } from '../../lib/auth';
import styles from './Login.module.css';
import logoUrl from '../../../logo-preta.png';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await login(email, password);
      // AuthGuard detecta a sessão no localStorage e desbloqueia automaticamente
      window.location.reload();
    } catch {
      setError('Email ou senha incorretos.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <img src={logoUrl} alt="Irmãos Polícia" className={styles.logo} />
        <h2 className={styles.title}>Portal de Gestão</h2>
        <p className={styles.subtitle}>Faça login para acessar o sistema</p>

        <form onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label htmlFor="loginEmail">Email</label>
            <input
              id="loginEmail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              autoComplete="email"
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="loginSenha">Senha</label>
            <input
              id="loginSenha"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" disabled={loading} className={styles.button}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>

          {error && <p className={styles.error}>{error}</p>}
        </form>
      </div>
    </div>
  );
}
